import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center" }
const _hoisted_2 = { ref: "qrCanvas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseStyle = _resolveComponent("BaseStyle")!

  return (_openBlock(), _createBlock(_component_BaseStyle, {
    model: _ctx.model,
    class: "content-base"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("canvas", _hoisted_2, null, 512), [
          [_vShow, _ctx.qrCode]
        ]),
        _withDirectives(_createElementVNode("div", null, " QRコードは見つかりません。 ", 512), [
          [_vShow, !_ctx.qrCode]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}